import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import Spinner from "react-bootstrap/Spinner";
import Top from "../components/Top";
import { API_BASE_URL } from "../api/config";
import "../index.css";

function Careers() {
  const { isLoading, isError, data, error } = useQuery({
    queryKey: ["career-listings"],
    queryFn: async () => {
      const res = await fetch(
        `${API_BASE_URL}/api/user/career_listings?limit=50`
      );
      return await res.json();
    },
  });

  if (isLoading) {
    return (
      <div
        className="d-flex flex-column justify-content-center align-items-center"
        style={{ height: "50vh" }}
      >
        <Spinner
          animation="border"
          role="status"
          style={{ height: "89px", width: "89px" }}
        >
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <p className="mt-3">Kindly be patient while we fetch your data</p>
      </div>
    );
  }

  if (isError) {
    return <p>An Error Occurred: {error.message}</p>;
  }

  const listings = data?.data ?? [];

  return (
    <div className="careers-page">
      <div className="container careers-content">
        <div className="careers-header">
          <h6>Join Our Team</h6>
          <h3>Career Opportunities</h3>
          <p className="careers-subtitle">
            Explore exciting career opportunities at AAER and be part of
            revolutionizing legal technology in Africa.
          </p>
        </div>
        {listings.length === 0 ? (
          <div className="text-center py-5">
            <h5>No open positions at the moment</h5>
            <p>Please check back later for new opportunities.</p>
          </div>
        ) : (
          <div className="row">
            {listings.map((listing) => (
              <div className="col-12 col-md-6 col-lg-4 mb-4" key={listing.id}>
                <Link
                  to={`/careers/${listing.id}`}
                  className="text-decoration-none"
                  style={{ color: "var(--text-color)" }}
                >
                  <div className="career-card">
                    <h4 className="career-card-title">{listing.title}</h4>
                    <div className="career-card-meta">
                      {listing.department && (
                        <span className="career-tag">
                          <i className="fas fa-building"></i> {listing.department}
                        </span>
                      )}
                      <span className="career-tag">
                        <i className="fas fa-map-marker-alt"></i> {listing.location}
                      </span>
                      <span className="career-tag">
                        <i className="fas fa-briefcase"></i> {listing.employment_type}
                      </span>
                      <span className="career-tag">
                        <i className="fas fa-laptop-house"></i> {listing.work_mode}
                      </span>
                    </div>
                    {listing.summary && (
                      <p className="career-card-summary">{listing.summary}</p>
                    )}
                    {listing.application_deadline && (
                      <p className="career-deadline">
                        <i className="fas fa-calendar-alt"></i> Deadline:{" "}
                        {new Date(listing.application_deadline).toLocaleDateString()}
                      </p>
                    )}
                    <span className="career-view-link">View Details →</span>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
      <Top />
    </div>
  );
}

export default Careers;
